// extracted by mini-css-extract-plugin
var _1 = "Collapsible_collapsible__28yfI";
var _2 = "Collapsible_content__2rHz4";
var _3 = "Collapsible_contentOpen__y4-54";
var _4 = "Collapsible_iconClosed__bFnIo";
var _5 = "Collapsible_iconOpen__7juyE";
var _6 = "Collapsible_title__lL3j9";
export { _1 as "collapsible", _2 as "content", _3 as "contentOpen", _4 as "iconClosed", _5 as "iconOpen", _6 as "title" }
